<div
  [ngClass]="params.data.originalValue?.[params.colDef.field]?.value !== value ? 'edited' : ''"
  class="cell-renderer-text">
  @if (onHoldDecode(+value)?.length > 0 || value === 0 || value === -1 || value === '0') {
    <div
      >{{ value }}
    </div>
  } @else {
    <div class="error-text">
      On Hold Code Does Not Exist
    </div>
  }
  @if (params.data.originalValue?.[params.colDef.field]?.value !== value && (params.context?.isStockManager || !params.data.disabled)) {
    <app-icon-backspace-outline
      (click)="onUndoChangesClick()"
      [tooltip]="'Previous Value = ' +params.data.originalValue[params.colDef.field].value">
    </app-icon-backspace-outline>
  }
</div>

